const LABELS = {
  TITLES: {
    LAST_UPDATED: 'Última alteração: '
  }
};

export default LABELS;
